<template>
  <div>
    <div class="flex">
      <EmailDeliveryStatCard
        title="Total"
        :count="deliveries.meta.deliveryCount"
      />
      <EmailDeliveryStatCard
        title="Delivered"
        :count="deliveries.meta.deliveredCount"
      />
      <EmailDeliveryStatCard
        title="Opened"
        :count="deliveries.meta.openedCount"
      />
      <EmailDeliveryStatCard
        title="Failed"
        :count="deliveries.meta.failedCount"
      />
    </div>
    <div class="p-3 flex justify-end">
      <button
        v-if="deliveries.data.length"
        type="button"
        class="btn-primary btn--sm btn mr-4"
        @click="openAuthCodeModal = true"
        v-text="'Export Deliveries'"
      />
      <button
        type="button"
        class="btn-primary btn--sm btn"
        @click="handleResend"
        v-text="'Resend Unopened'"
      />
      <AuthCodeModal
        :open="openAuthCodeModal"
        @closeModal="openAuthCodeModal = false"
        @authCodeVerified="downloadExport"
      />
    </div>
    <EmailDeliveryFilter v-model="queryString" />
    <ContentSectionLoader
      v-if="loading"
      :loading="loading"
    />
    <div
      v-else
      class="table-responsive"
    >
      <table class="table table-data min-w-table">
        <thead>
          <tr>
            <th v-text="'First Name'" />
            <th v-text="'Last Name'" />
            <th v-text="'Email'" />
            <th
              class="w-16"
              v-text="'Status'"
            />
            <th v-text="'Status Timestamp'" />
            <th v-text="'Is Retry'" />
          </tr>
        </thead>
        <tbody>
          <EmailDeliveryRow
            v-for="delivery in deliveries.data"
            :key="delivery.uuid"
            :delivery="delivery"
          />
        </tbody>
      </table>
      <Pagination
        v-if="!loading"
        :on-change="fetchDeliveries"
        :pagination="deliveries.meta.pagination"
      />
    </div>
  </div>
</template>

<script type="text/babel">
import _ from 'lodash'
import {mapActions, mapState} from 'vuex'
import EmailDeliveryRow from './EmailDeliveryRow'
import EmailDeliveryStatCard from './EmailDeliveryStatCard'
import Pagination from 'Base/Resources/assets/js/components/Pagination'
import EmailDeliveryFilter from './EmailDeliveryFilter.vue'
import URI from 'urijs'
import ContentSectionLoader from 'Base/Resources/assets/js/components/ContentSectionLoader.vue'

export default {
  name: 'EmailDeliveries',
  components: {
    ContentSectionLoader,
    EmailDeliveryFilter,
    EmailDeliveryRow,
    Pagination,
    EmailDeliveryStatCard,
  },
  props: {
    uuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      openAuthCodeModal: false,
      queryString: {
        search: '',
        page: 1,
        filter: 'all',
      },
    }
  },
  computed: {
    ...mapState({
      deliveries: state => state.communication.EmailDeliveries,
    }),
  },
  watch: {
    queryString: {
      handler: _.debounce(function () {
        history.pushState(null, null, this.fetchUrl)

        this.fetchDeliveries()
      }, 500),
      deep: true,
    },
  },
  async mounted() {
    await this.$nextTick()

    this.queryString = Object.assign(this.queryString, new URI().query(true))

    await this.fetchDeliveries()
  },
  methods: {
    ...mapActions({
      setEmailDeliveries: 'communicationSetEmailDeliveries',
      retryEmailDeliveries: 'communicationRetryEmailDeliveries',
    }),
    async fetchDeliveries(page = 1) {
      if (this.loading) {
        return
      }

      this.loading = true

      await this.setEmailDeliveries({
        ...this.queryString,
        uuid: this.uuid,
        page: page,
      })

      window.scrollTo(0, 0)

      this.loading = false
    },
    downloadExport() {
      this.openAuthCodeModal = false

      let urlString = this.$urlGenerator.active() + 'communications/email/' + this.uuid + '/deliveries/export'

      urlString += '?filter=' + this.queryString.filter
      urlString += '&search=' + this.queryString.search

      axios.get(urlString, {
        responseType: 'blob',
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))

        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${this.deliveries.meta.emailSubject}-deliveries.csv`)

        document.body.appendChild(link)

        link.click()
      })
    },
    handleResend() {
      this.retryEmailDeliveries({
        emailUuid: this.uuid,
      }).then(() => {
        this.$store.commit('baseAddNotification', {
          type: 'success',
          text: 'Emails have been resent.',
        })
      }).catch(() => {
        this.$store.commit('baseAddNotification', {
          type: 'error',
          text: 'There was an error resending the emails.',
        })
      })
    },
  },
}
</script>
